import Right from '@/assets/right.png';
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import store from '@/store';
import TopTitle from '@/components/TopTitle.vue';
export default {
  name: 'CollectHome',
  components: {
    TopTitle
  },

  setup() {
    const router = useRouter();
    const route = useRoute();

    if (route.query.channel !== undefined && route.query.channel !== null && route.query.channel === 'huawei') {
      route;
    }

    const info = computed(() => {
      return store.getters.invInfo;
    });

    const back = () => {
      if (window.HybridAPI !== undefined) {
        const param = {
          method: 'closeWindow',
          params: {
            url: info.value.url
          },
          callback: ''
        };
        window.HybridAPI.sendToNative(JSON.stringify(param));
      } else {
        router.back();
        window.close();
      }
    };

    return {
      Right,
      back,
      router,
      info
    };
  }

};